<button
  class="button button-secondary w-full justify-center"
  [ngClass]="{ 'button-secondary': !isSelected }"
  (click)="select()"
  [disabled]="isDisabled">
  <ng-content></ng-content>
</button>
